import { normalizeMeetingResult } from '../domain/meetingResult';

/**
 * Format a meeting into an email body.
 *
 * Action items are normalized ONCE through the domain module (deduplicating
 * legacy `actions` and `action_items`, and merging structured analysis action
 * items) so the output can never duplicate them.
 *
 * @param {Object} meeting
 * @param {Object} [options]
 * @param {boolean} [options.includeTranscript=true] - Include the full transcription.
 * @returns {string}
 */
export const buildMeetingEmail = (meeting, { includeTranscript = true } = {}) => {
  if (!meeting) return '';

  const normalized = normalizeMeetingResult(meeting);
  const meetingDate = new Date(meeting.createdAt).toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  let emailBody = `Meeting Summary\n\n`;
  emailBody += `Meeting: ${meeting.title}\n`;
  emailBody += `Date: ${meetingDate}\n`;

  if (meeting.uploadedBy && meeting.uploadedBy.firstName) {
    emailBody += `Attendees: ${meeting.uploadedBy.firstName} ${meeting.uploadedBy.lastName}\n\n`;
  } else {
    emailBody += `\n`;
  }

  // Prefer the structured analysis summary, falling back to the legacy summary.
  const summary = normalized.analysis.summary || meeting.summary;
  if (summary) {
    emailBody += `Summary:\n${summary}\n\n`;
  }

  if (normalized.actionItems.length > 0) {
    emailBody += `Action Items:\n`;
    normalized.actionItems.forEach((item, index) => {
      emailBody += `${index + 1}. ${item}\n`;
    });
    emailBody += `\n`;
  }

  if (includeTranscript && normalized.effectiveTranscript) {
    emailBody += `Full Transcription:\n${normalized.effectiveTranscript}\n`;
  }

  return emailBody;
};